export default __webpack_public_path__ + "static/media/cake-1.7663c608.jpeg";